// buildHotelResultMessage — pure construction of the hotel-results header text.
//
// Extracted verbatim from `AIChatBot.js` (module-level `buildHotelResultMessage`)
// as part of the behavior-preserving refactor (issue #240). Builds the
// "Here are [brand ][location ]in [destination]:" string, omitting the brand
// fragment when no brand filter is set ('no preference') and omitting the
// location fragment when none was chosen.
//
// React-free and side-effect-free. The string assembly is preserved exactly so
// the committed characterization snapshots stay stable.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Builds the hotel-results header message.
 *
 * @param {Object} finalParams - Collected flow params (brand, locationHint).
 * @param {string} destination - The resolved destination label.
 * @returns {string} The results header string.
 */
export function buildHotelResultMessage(finalParams, destination) {
  const hasBrandFilter = finalParams.brand && finalParams.brand !== 'no preference';
  const brandLabel = hasBrandFilter ? finalParams.brand + ' ' : '';
  const locLabel = finalParams.locationHint ? finalParams.locationHint + ' ' : '';
  return `Here are ${brandLabel}hotels ${locLabel}in ${destination}:`;
}

export default buildHotelResultMessage;
